module.exports = __webpack_public_path__ + "static/media/diamonds_5.e6e956f5.png";